import React, { useState } from 'react'
import PropTypes from 'prop-types'

export default function InputSwitchComponent(props) {
  const value = props.value || props.val1

  const onChangeValue = () => {
    props.onChange(value == props.val1 ? props.val2 : props.val1)
  }

  return (
    <div className={`c-input c-switch ${value === props.val2 ? 'c-switch--active' : ''}`}>
      <div className="c-switch__title c-input__label">{props.label}</div>
      <div className="c-switch__label c-switch__label--inactive">{props.lab1}</div>
      <div className="c-switch__label c-switch__label--active">{props.lab2}</div>
      <button onClick={onChangeValue} className="c-switch__button"></button>
    </div>
  )
}

InputSwitchComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  val1: PropTypes.any,
  val2: PropTypes.any,
  lab1: PropTypes.string,
  lab2: PropTypes.string,
  lablarge: PropTypes.bool
}

InputSwitchComponent.defaultProps = {}
